// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v1.4.8-6-g9bb3a5d3",
    "hash": "g9bb3a5d3",
    "distance": 6,
    "tag": "v1.4.8",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.4.8",
        "major": 1,
        "minor": 4,
        "patch": 8,
        "prerelease": [],
        "build": [],
        "version": "1.4.8"
    },
    "suffix": "6-g9bb3a5d3",
    "semverString": "1.4.8+6.g9bb3a5d3",
    "version": "1.4.8"
};
/* tslint:enable */
